var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"columns":_vm.columns,"group-actions":_vm.groupActions,"list":_vm.list,"single-actions":_vm.singleActions}})
}
var staticRenderFns = []

export { render, staticRenderFns }